// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eC","imgTextCardBox":"eC","text-box":"eD","textBox":"eD","remark-val":"eE","remarkVal":"eE"};